import React, { useEffect } from "react"
import { useImmerReducer } from "use-immer"
import Axios from "axios"

// My Components
import { SingleMovieHero, BudgetBar, Actor, Page, Breadcrumb, Rating } from "../../components"
import { Grid } from "../../containers"
import { useParams } from "react-router-dom"
import { calcTime } from "../../helpers/calculate"
import { IMAGE_BASE_URL, API_URL, API_KEY, POSTER_SIZE, BACKDROP_SIZE } from "../../helpers/config"

function Movie() {
  const { movieId } = useParams()
  const NoImage = "https://i.ibb.co/bmkvfbv/No-image.jpg"
  const initialState = {
    movie: {
      adult: false,
      backdrop_path: "",
      belongs_to_collection: {},
      budget: "",
      genres: [],
      homepage: "",
      id: "",
      imdb_id: "",
      original_language: "",
      original_title: "",
      overview: "",
      popularity: "",
      poster_path: "",
      production_companies: [],
      production_countries: [],
      release_date: "",
      revenue: "",
      runtime: "",
      spoken_languages: [],
      status: "",
      tagline: "",
      title: "",
      video: false,
      vote_average: "",
      vote_count: "",
    },
    credit: {
      id: "",
      cast: [
        {
          adult: "",
          gender: "",
          id: "",
          known_for_department: "",
          name: "",
          original_name: "",
          popularity: "",
          profile_path: "",
          cast_id: "",
          character: "",
          credit_id: "",
          order: "",
        },
      ],
      crew: [
        {
          adult: false,
          gender: "",
          id: "",
          known_for_department: "",
          name: "",
          original_name: "",
          popularity: "",
          profile_path: "",
          credit_id: "",
          department: "",
          job: "",
        },
      ],
    },
    director: {
      adult: "",
      gender: "",
      id: "",
      known_for_department: "",
      name: "",
      original_name: "",
      popularity: "",
      profile_path: "",
      credit_id: "",
      department: "",
      job: "",
    },
    isFetching: true,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadMovieInfo":
        draft.movie = action.data
        return
      case "loadMovieCredit":
        draft.credit = action.data
        return
      case "isFetching":
        draft.isFetching = action.value
        return
      case "whosDirector":
        draft.director = action.data
        return
      default:
        console.log("default")
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  const fetchMovieInfo = async (ourRequest) => {
    try {
      const response = await Axios.get(`${API_URL}movie/${movieId}?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (response.data) {
        dispatch({ type: "loadMovieInfo", data: response.data })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMoviecredit = async (ourRequest) => {
    try {
      const response = await Axios.get(`${API_URL}movie/${movieId}/credits?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (response.data) {
        dispatch({ type: "loadMovieCredit", data: response.data })
        dispatch({ type: "isFetching", value: false })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRequest = Axios.CancelToken.source()
    fetchMovieInfo(ourRequest)
    fetchMoviecredit(ourRequest)

    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movieId])

  useEffect(() => {
    if (state.credit) {
      let dirData = state.credit.crew.filter((member) => member.job === "Director")
      dispatch({ type: "whosDirector", data: dirData[0] })
    }
    // eslint-disable-next-line
  }, [state.credit])

  return (
    <Page title={state.movie.title} disc={state.movie.overview}>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item title={state.movie.title} />
        </Breadcrumb.List>
      </Breadcrumb>
      <SingleMovieHero path={state.movie.backdrop_path ? `${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.movie.backdrop_path}` : ""}>
        <SingleMovieHero.Thumbnail src={state.movie.poster_path} />
        <SingleMovieHero.Content>
          <Rating rate={state.movie.vote_average} />
          <SingleMovieHero.Name year={state.movie.release_date.substring(0, 4)}>{state.movie.title}</SingleMovieHero.Name>
          <SingleMovieHero.GContainer>
            {state.movie.genres.map((genere, index) => {
              return (
                <SingleMovieHero.GLink key={index} to={`/genre/${genere.id}/movie`}>
                  {genere.name}
                </SingleMovieHero.GLink>
              )
            })}
          </SingleMovieHero.GContainer>
          <SingleMovieHero.TimeAndDate>
            <SingleMovieHero.IconWithText icon="ph-clock" text={calcTime(state.movie.runtime)} />
            <SingleMovieHero.IconWithText icon="ph-calendar-blank" text={state.movie.release_date} />
          </SingleMovieHero.TimeAndDate>
          <SingleMovieHero.Title>Overview</SingleMovieHero.Title>
          <SingleMovieHero.OverviewText>{state.movie.overview}</SingleMovieHero.OverviewText>
          <SingleMovieHero.Title>DIRECTOR</SingleMovieHero.Title>
          <SingleMovieHero.Text>{state.director && state.director.name}</SingleMovieHero.Text>
        </SingleMovieHero.Content>
      </SingleMovieHero>
      <BudgetBar>
        <BudgetBar.Duration text={state.movie.runtime} />
        <BudgetBar.Budget text={state.movie.budget} />
        <BudgetBar.Revenue text={state.movie.revenue} />
      </BudgetBar>

      <Grid title="Casting Actors">
        <Grid.Body>
          {state.credit.cast.map((cast, index) => {
            return (
              <Actor key={index} to={`/actor/${cast.id}`}>
                <Actor.Thumbnail src={cast.profile_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${cast.profile_path}` : NoImage} />
                <Actor.Name>{cast.original_name}</Actor.Name>
                <Actor.InMovieName>{cast.character}</Actor.InMovieName>
              </Actor>
            )
          })}
          {state.isFetching && (
            <>
              <Actor to="#">
                <Actor.ThumbSkeleton />
                <Actor.Name></Actor.Name>
                <Actor.InMovieName></Actor.InMovieName>
              </Actor>
              <Actor to="#">
                <Actor.ThumbSkeleton />
                <Actor.Name></Actor.Name>
                <Actor.InMovieName></Actor.InMovieName>
              </Actor>
              <Actor to="#">
                <Actor.ThumbSkeleton />
                <Actor.Name></Actor.Name>
                <Actor.InMovieName></Actor.InMovieName>
              </Actor>
              <Actor to="#">
                <Actor.ThumbSkeleton />
                <Actor.Name></Actor.Name>
                <Actor.InMovieName></Actor.InMovieName>
              </Actor>
              <Actor to="#">
                <Actor.ThumbSkeleton />
                <Actor.Name></Actor.Name>
                <Actor.InMovieName></Actor.InMovieName>
              </Actor>
            </>
          )}
        </Grid.Body>
      </Grid>
    </Page>
  )
}

export default Movie
